/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_TitleInputs */

const en_admin_posts_title = /** @type {(inputs: Admin_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posts`)
};

const zh_admin_posts_title = /** @type {(inputs: Admin_Posts_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文章管理`)
};

/**
* | output |
* | --- |
* | "Posts" |
*
* @param {Admin_Posts_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_posts_title = /** @type {((inputs?: Admin_Posts_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_posts_title(inputs)
	return zh_admin_posts_title(inputs)
});
export { admin_posts_title as "admin.posts.title" }